import { GET, POST, PUT, DELETE } from "../../../../../module/services/fetch";
import { map } from "rxjs/operators";
import { IReportParameter } from "../../module/constants";


export const getParameters = () => {
  return GET('reports/parameters')
        .pipe(map ( (res: any) => res));
};

export const postParameter = (data: IReportParameter) => {
  return POST('reports/parameters', data)
        .pipe(map ( (res: any) => res));
}

export const putParameter = (data: IReportParameter) => {
  return PUT('reports/parameters', data)
        .pipe(map ( (res: any) => res));
};

export const deleteParameter = (data: IReportParameter) => {
  return DELETE('reports/parameters', data)
        .pipe(map ( (res: any) => res));
};